export default {"src":"/_next/static/media/highlightgoals.29b6730b.svg","height":180,"width":284};